<app-help [link]="bookMeeting" [type]="'lp'"></app-help>
<div class="container-fluid" style="padding-left: 0">
  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8 box-col-12">
      <div class="card">
        <div class="card-header p-b-0">
          <div class="d-flex align-items-baseline">
            <i class="icofont icofont-abacus-alt" style="font-size: 18px"></i>
            <h4 class="ps-2 m-r-5 m-b-0">
              {{ "newCampaign.step2.title" | translate }}
            </h4>
          </div>
        </div>
        <div class="card-body">
          <app-video-guidelines-and-upload
            [note]="'location.promote.note'"
            (emitFileName)="catchFileName($event)"
          ></app-video-guidelines-and-upload>
        </div>
        <div class="card-footer">
          <div
            style="display: flex; justify-content: end"
            class="m-r-30 m-t-10"
          >
            <button
              class="btn btn-primary"
              (click)="onSubmit()"
              [disabled]="!filename || loading"
            >
              <loading-button
                [loading]="loading"
                [value]="'buttons.confirm' | translate"
                [icon]="null"
              ></loading-button>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 box-col-12">
      <h4>{{ "location.promote.preview" | translate }}</h4>
      <hr />
      <div class="col-6 col-lg-9 col-xxl-6" style="margin: auto">
        <app-ad-video-preview></app-ad-video-preview>
      </div>
    </div>
  </div>
</div>
